import React from "react";
import {markdownToHtmlConverter} from "../../../utils/markdownConverter";
import "./markdownToHtmlViewer.sass";
import parse from "html-react-parser";

export interface IMarkdownToHtmlViewer {
  markdownText: string;
}

const MarkdownToHtmlViewer: React.FC<IMarkdownToHtmlViewer> = ({
  markdownText
}) => {
  const htmlText = markdownToHtmlConverter(markdownText);

  return <div className="markdown-html-viewer">{parse(htmlText)}</div>;
};

export default MarkdownToHtmlViewer;
